import { render, staticRenderFns } from "./IconHeartOutline.vue?vue&type=template&id=8f3a56c2"
import script from "./IconHeartOutline.vue?vue&type=script&lang=js"
export * from "./IconHeartOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports